import axios, { axiosInstanceNoInterceptors } from './axiosInstance';
import { APIUser } from '../../types';

interface UpdateUserParams {
  userName?: string;
  email?: string;
  name?: string;
}

interface MagicAuthTokenResponse {
  magicToken: string;
}

interface EnableTotpResponse {
  secret: string;
  qrCodeUrl: string;
}

const getUser = (): Promise<APIUser | undefined> => {
  return axios
    .get('/user')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return undefined;
    });
};

/**
 * This function is used to get the user without the axios interceptor
 * So, if we get a 401 or 404, we aren't redirected to the login page
 */
const getUserNoInterceptors = (): Promise<APIUser | undefined> => {
  return axiosInstanceNoInterceptors
    .get('/user')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return undefined;
    });
};

const getUserAuth = (): Promise<APIUser | undefined> => {
  return axios
    .get('/user/auth')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      return undefined;
    });
};

const requestVerifyEmail = (): Promise<void> => {
  return axios
    .get('/user/requestverifyemail')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const updateUser = ({ userName, email, name }: UpdateUserParams): Promise<APIUser> => {
  return axios
    .post('/user', {
      ...(userName ? { userName: userName.trim() } : null),
      ...(email ? { email: email.trim() } : null),
      ...(name ? { name: name.trim() } : null),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getMagicAuthToken = (): Promise<MagicAuthTokenResponse> => {
  return axios
    .get('/user/magicauthtoken')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const enableTotpMfa = (): Promise<EnableTotpResponse> => {
  return axios
    .post('/user/mfa/totp/enable')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const verifyTotpMfa = (totp: string): Promise<void> => {
  return axios
    .post('/user/mfa/totp/verify', { totp })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const disableMfaTotp = (): Promise<void> => {
  return axios
    .post('/user/mfa/totp/disable')
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const userFunctions = {
  getUser,
  getUserNoInterceptors,
  getUserAuth,
  requestVerifyEmail,
  updateUser,
  getMagicAuthToken,
  enableTotpMfa,
  verifyTotpMfa,
  disableMfaTotp,
};

export default userFunctions;
